class YGAnchorTab extends HTMLElement {
  constructor() {
    super()
    this.init()
  }
  init() {
    let sectionBox = this.closest('.yg-anchor-section')
    this.calculateTopVlue(sectionBox)
  }

  calculateTopVlue(sectionBox){
    let sectionTop = sectionBox.nextElementSibling.getBoundingClientRect().top + window.scrollY
    let tabForm = sectionBox.querySelector('.yg-anchor-tab-form')
    let scrollTimer;
    let ygSectionList = document.querySelectorAll('#MainContent .shopify-section'),
        ygProductTab = this.querySelectorAll('li');

    const options = {
      threshold: [0.7]
    }

    const intersectionObserver = new IntersectionObserver((entries) => {
      // and we do not need to do anything.
      if (entries[0].intersectionRatio > 0.7 ){
        ygProductTab.forEach((productTab) => {
        
          if(entries[0].target.getAttribute('data-section-number') == productTab.getAttribute('data-section-number')){
            ygProductTab.forEach((a) => {
                a.classList.remove('active');
              });
              // 给当前点击项添加激活类
              productTab.classList.add('active');
            }
          });
      }
    },options);    

    ygProductTab.forEach(function (e) {
      e.onclick = function () {
        // 获取点击项的data-section-number属性值
        let number = e.getAttribute('data-section-number');
        // 遍历ygProductTab，移除所有激活类
        ygProductTab.forEach((a) => {
          a.classList.remove('active');
        });
        // start observing
        ygSectionList.forEach(function (Section,i){
          Section.setAttribute("data-section-number", i)
          intersectionObserver.unobserve(Section);
        })
        
        // 给当前点击项添加激活类
        e.classList.add('active');
        if (number) {
          // 通过属性值获取dom节点
          let pointDom = ygSectionList[number];
          // 计算滚动距离
          let pointTop =
            pointDom.offsetTop - parseInt(sectionBox.style.top) - sectionBox.getBoundingClientRect().height - 30;
          // 滑动到指定dom节点
          window.scrollTo({
            top: pointTop,
            behavior: 'smooth',
          });
        }
        setTimeout(() => {
          startObserving()
        }, 600);
      };
    });

    function startObserving(){
      // start observing
      ygSectionList.forEach(function (Section,i){
        Section.setAttribute("data-section-number", i)
        intersectionObserver.observe(Section);
      })
    }

    startObserving()

    // 添加滚动事件监听器
    window.addEventListener('scroll', function () {
      // 清除之前的定时器
      clearTimeout(scrollTimer);

      // 设置新的定时器
      scrollTimer = setTimeout(function () {
        // 在页面滚动停止后执行的操作
        const headerSection = document.querySelector('.shopify-section-header');
        let { height, top } = headerSection.getBoundingClientRect();
        // 剩下的代码保持不变
        if (headerSection) {
          let btnBoxTop = height + top >= 0 ? height - 1 + top : 0;
          sectionBox.style.top = btnBoxTop + 'px';
        }

        if(sectionTop > window.scrollY){
          tabForm.classList.remove('active')
        } else {
          tabForm.classList.add('active')
        }
      }, 150); // 这里的 250 是延迟时间，单位为毫秒
    });
  }
}
if (!window.customElements.get('yg-anchor-tab')) {
    window.customElements.define('yg-anchor-tab', YGAnchorTab)
}

class YGTabForm extends HTMLElement {
    constructor() {
      super()
      this.triggerSelect()
      this.addToCart()
      this.mobileScroll()
    }

    triggerSelect() {
        // 这里放置自定义逻辑
        const select = this.querySelector('select')
        let variantList = document.querySelector('variant-radios')
        let variants = []
        if (variantList){
          let [variant1, variant2, variant3] = variantList.querySelectorAll('fieldset')
          variants = [variant1, variant2, variant3]
        }
        
        let radioValues = []

        select?.addEventListener('change', () => {
          let variantOptions = select.value
          let [option1, option2, option3] = variantOptions.split('/')

          if (variant1) {
            variant1.querySelector('input[value="' + option1.trim() + '"]').click()
          }
          if (variant2) {
            variant2.querySelector('input[value="' + option2.trim() + '"]').click()
          }
          if (variant3) {
            variant3.querySelector('input[value="' + option3.trim() + '"]').click()
          }

          setTimeout(() => {
            unDataPrice()
          }, 800)
        })

        variants.forEach((variant) => {
          if (!variant) return
          let inputList = variant.querySelectorAll('input[type="radio"]')

          inputList.forEach((input) => {
            input.addEventListener('change', () => {
              let values = radioChange()
              setTimeout(() => {
               unDataPrice()
              }, 800)
            }) 
          })
        })

        function radioChange() {
          radioValues = []
          variants.forEach((variant) => {
            if (!variant) return
            let inputList = variant.querySelectorAll('input[type="radio"]')
            inputList.forEach((input) => {
              if (input.checked) {
                radioValues.push(input.value)
              }
            })
          })

          return select.value = radioValues.join(' / ')
        }

        let unDataPrice = () => {
          let price = document.querySelector('.price.price--product')

          let regularPriceValue = price.querySelector('.price__regular .price-item.price-item--regular')
          let comparePriceValue = price.querySelector('.price__sale .price-item.price-item--regular')

          this.querySelector('.price--regular').textContent = regularPriceValue.innerHTML
          this.querySelector('.price--sale').textContent = comparePriceValue.innerHTML
        }
        
    }

    addToCart (){
      let button = this.querySelector('.btn')
      button.addEventListener('click', () => {
			let $addCartButtons = document.querySelectorAll(
				'.product-form__submit[name="add"][type="submit"]'
			)

			if ($addCartButtons[0].hasAttribute('disabled')) {
				$addCartButtons[1].click()
			} else {
				$addCartButtons[0].click()
			}
      })
    }

    mobileScroll() {
      let button = this.closest('.yg-anchor-section').querySelector('.mobile-btn')
      let addToCart = document.querySelector('.product-form__submit')

      window.addEventListener('scroll', () =>{
        if(addToCart.getBoundingClientRect().top < -300){
          button.style.bottom = '12px'
        } else {
          button.style.bottom = '-50px'
        }
      });

      button.addEventListener('click', () => {
        window.scrollTo({
          top: addToCart.offsetTop - 50,
          behavior: 'smooth',
        });
      })
    }
}

if (!window.customElements.get('yg-tab-form')) {
    window.customElements.define('yg-tab-form',YGTabForm)
}

// 阶梯价格

document.cookie = 'locale_bar_accepted=; Max-Age=0; path=/'; 

document.addEventListener('DOMContentLoaded', () => {
  (function(){
    let getCartItemCount = async (variantID) => {
      const url = `/cart.js`; // 构建请求的 URL
      let data = null

      try {
          const response = await fetch(url); // 发送 GET 请求
  
          if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          data = await response.json(); // 解析 JSON 数据
  
      } catch (error) {
          console.error('请求失败:', error); // 输出错误信息
          return 0
      }

      //匹配当前变体
      const variant = data.items.find(item => item.id === Number(variantID));
      if (variant) {
        return variant.quantity
      } else {
        return 0
      }
    }

    let fetchRequest = (fn) => {
      // 保存原有的 fetch 方法
      let originalFetch = window.fetch;
        
      window.fetch = function(...args) {
          const [resource, config] = args;
      
          return originalFetch(...args)
              .then(response => {
                  // 检查响应状态
                  if (response.ok) {
                      // 检测请求的 URL 是否为 add 或 change
                      if (typeof resource === 'string' && resource.includes('add') || resource.includes('change')) {
                          console.log('检测到返回请求数据');
                          fn()
                      }
                  }
                  return response; // 如果不是目标请求，直接返回响应
              })
              .catch(error => {
                  console.error('请求失败:', error);
                  throw error; // 抛出错误，供后续处理
              });
      };
    }

    let getSectionHTML = async (url) => {

      let quantityInput = null
      let priceBreaks = null;
      let quantityRules = null;

      await fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          // Replace the current HTML in DOM with the updated HTML
        
          const updatedHtml = new DOMParser().parseFromString(
            responseText,
            'text/html',
          );
          
          quantityInput = updatedHtml.querySelector('.quantity__input')
          priceBreaks = updatedHtml.querySelector('.yg-price-breaks-box')
          quantityRules = updatedHtml.querySelector('.yg-quantity-rules')
        });

      return {quantityInput, priceBreaks, quantityRules}
    }

    let mainBox = document.querySelector('.yg-b2b-price')
    let sectionID = mainBox?.getAttribute('data-section')
    let productUrl = mainBox.getAttribute('data-product-url')
    let variantID = mainBox.getAttribute('data-variant')
    let quantityInput = mainBox.querySelector('.quantity__input')

    if (!mainBox) { return }

    let unDataPrice = () => {
      let priceBox = mainBox.querySelector('.price .price__regular .price-item--regular')
      let tabPriceBox = document.querySelector('.yg-tab-form__price .price--regular')
      let quantityValue = quantityInput.value
      let priceBreaks = mainBox.querySelectorAll('.yg-price-breaks .yg-price-break')
      let quantityTip = mainBox.querySelector('.yg-quantity-tip')
      let quantityUnit = quantityTip.getAttribute('data-unit')
      
        getCartItemCount(variantID).then(res =>{ 
          let quantity = Number(quantityValue) + Number(res)
          let nextBreak = null
          let currentprice = null
  
          if (priceBreaks.length > 0) {
            let frish = true
            priceBreaks.forEach((priceBreak, index) => {
              if (priceBreak.getAttribute('data-minimum-quantity') > quantity && frish == true) {
                nextBreak = Number(priceBreak.getAttribute('data-minimum-quantity'))
                currentprice = priceBreaks[index-1].getAttribute('data-break-price')
  
                frish = false
              } else if (priceBreaks.length == index + 1  && frish == true){
                currentprice = priceBreak.getAttribute('data-break-price')
                frish = false
              }
            })
  
            priceBox.innerHTML = currentprice
            tabPriceBox.innerHTML = currentprice
            
            if (quantityUnit != ' ') {
              quantityTip.innerHTML = `${res} ${quantityUnit} Selected`
            } else {
              quantityTip.innerHTML = `${res} Pieces Selected`
            }
            
            // if (res > 0) {
            //   quantityTip.innerHTML = `Quantity (${res} in Cart) &nbsp&nbsp at ${currentprice}/ea.`

            //   // quantityInput.setAttribute('min', quantityInput.getAttribute('data-min') - res > 0 ? quantityInput.getAttribute('data-min') - res: quantityInput.getAttribute('step'))

            //   // if (quantityInput.getAttribute('max')) {
            //   //   quantityInput.setAttribute('max', quantityInput.getAttribute('data-max') - res)
            //   //   quantityInput.setAttribute('value', quantityInput.getAttribute('value') + res > quantityInput.getAttribute('data-max') ? quantityInput.getAttribute('data-max'): quantityInput.getAttribute('value') + res)
            //   // }  

            // } else {
            //   quantityTip.innerHTML = `at ${currentprice}/ea.`
            // }
          } else {
            if (quantityUnit != ' ') {
              quantityTip.innerHTML = `${res} ${quantityUnit} Selected`
            } else {
              quantityTip.innerHTML = `${res} Pieces Selected`
            }
          }
        })


    }

    quantityInput.addEventListener('change', () => {
      unDataPrice()
    })
    fetchRequest(unDataPrice)

    let variantRadios = mainBox.querySelectorAll('fieldset input[type="radio"]')

    variantRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        setTimeout(function(){
          variantID = mainBox.querySelector('.singleProductPreOrderForm [name="id"]').value
          let url = `${productUrl}?section_id=${sectionID}&variant=${variantID}`
          let quantityInput = mainBox.querySelector('.quantity__input')
          let priceBreaks = mainBox.querySelector('.yg-price-breaks-box')
          let quantityRules = mainBox.querySelector('.yg-quantity-rules')

          getSectionHTML(url).then(res => {
            quantityInput.setAttribute('min', res.quantityInput.getAttribute('min'))
            if (res.quantityInput.getAttribute('max') != '') {
              quantityInput.setAttribute('max', res.quantityInput.getAttribute('max'))
            }
            quantityInput.setAttribute('step', res.quantityInput.getAttribute('step'))
            quantityInput.setAttribute('value', res.quantityInput.getAttribute('min'))
            priceBreaks.innerHTML = res.priceBreaks.innerHTML
            quantityRules.innerHTML = res.quantityRules.innerHTML
            unDataPrice()
          })
        },500)
        
      })
    })
    unDataPrice()
  }())
})

document.addEventListener('DOMContentLoaded', () => {
  (function(){
    let $ygMegaMenuList = document.querySelectorAll('.yg-mega-menu-columns')

    $ygMegaMenuList.forEach((megaMenu) => {
      let $tabList =megaMenu.querySelectorAll('.mega-menu__column-list-tab')

      $tabList.forEach((tab) => {
        tab.addEventListener('click', () => {
          tab.classList.toggle('active')
        })  
      })
    })
    
  }())
})


// 超级菜单

class YGMegaMenuJson extends HTMLElement {
    constructor() {
        super()
        this.init()
    }
    init() {
        // 这里放置初始化逻辑
        this.mouseIn()
    }
    mouseIn() {
        // 这里放置自定义逻辑
        let $tabList = this.querySelectorAll('.yg-menu-tab')
        let $tabContent = this.querySelectorAll('.yg-menu-contents')

        $tabList.forEach((tab, index) => {
          tab.addEventListener('mouseenter', () => {
            removeClass()

            tab.classList.add('active')
            $tabContent[index].classList.add('active')
          })
        })

        function removeClass() {
          $tabList.forEach((tab) => {
            tab.classList.remove('active')
          })
          $tabContent.forEach((content) => {
            content.classList.remove('active')
          })
        }
    }
}
if (!window.customElements.get('yg-mega-menu-json')) {
    window.customElements.define('yg-mega-menu-json', YGMegaMenuJson)
}

class YGArea extends HTMLElement {
  constructor() {
    super()
    this.init();
  }
  init(){
    this.activebutton()
    this.getRegion()
  }
  getRegion() {
    const subdomain = window.location.hostname.split('.')[0];
    if(subdomain === "www"){
  this.querySelector(".value").innerHTML = "AREA"
}else{
      this.querySelector(".value").innerHTML = subdomain;
}
  }
  activebutton(){
     const $button =  this.querySelector("button[type='button']")
     const $ul =  this.querySelector("ul")
     console.log(!Boolean($button.getAttribute("aria-expanded")))
     document.addEventListener("click", function(e) {
      // 判断点击是否在菜单区域外
      const isInside = $button.contains(e.target) || $ul.contains(e.target);
      
      if (!isInside) {
        // 关闭菜单
        $button.setAttribute("aria-expanded", "false");
        $ul.setAttribute("hidden", "");
      }
    });
     $button.addEventListener("click",function(){
      if($button.getAttribute("aria-expanded") == "false"){
        $button.setAttribute("aria-expanded",true)
        
      }else{
        $button.setAttribute("aria-expanded",false)
      }
      if($ul.hasAttribute("hidden")){
        $ul.removeAttribute("hidden")
      }else{
        $ul.setAttribute("hidden","")
      }
     })
    
  }
}
if(!window.customElements.get("yg-area")){
  window.customElements.define("yg-area",YGArea)
}